export default function ClockIco() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 2.91667V5H6.25M8.75 5C8.75 7.07108 7.07108 8.75 5 8.75C2.92893 8.75 1.25 7.07108 1.25 5C1.25 2.92893 2.92893 1.25 5 1.25C7.07108 1.25 8.75 2.92893 8.75 5Z"
        stroke="#8396A8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
